import { gql } from '@apollo/client';
export const GRADING_SCALE_FIELDS = gql `
  fragment GradingScaleFragment on GradingScale {
    id
    name
    isActive
    gradingScaleType
    gradeLevels
    extraData
    countries {
      id
      code
      name
    }
  }
`;
export const GET_GRADING_SCALES = gql `
  ${GRADING_SCALE_FIELDS}
  query GradingScales($spec: GradingScaleSpec!) {
    gradingScales(spec: $spec) {
      total
      page
      pageSize
      items {
        ...GradingScaleFragment
      }
    }
  }
`;
export const SAVE_GRADING_SCALE = gql `
  mutation SaveGradingScale($input: GradingScaleInput!) {
    saveGradingScale(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
// export const IS_GRADE_PASSING = gql`
//   query IsGradePassing($spec: IsGradePassingSpec!) {
//     isGradePassing(spec: $spec) {
//       isPassing
//       reason
//     }
//   }
// `;
